export default "__VITE_ASSET__0w8YKZ2r__"